'use client';

import React from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useClickOutside = (
  ref: React.MutableRefObject<HTMLElement | null>,
  callback: (event?: MouseEvent) => void,
): void => {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref?.current && !ref.current.contains(event.target as Node)) {
        callback(event);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener(
      'blur',
      () => {
        setTimeout(() => {
          if (document.activeElement?.tagName === 'IFRAME') {
            callback();
          }
        });
      },
      { once: true },
    );
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, ref]);
};
